import React from 'react';
import { Link } from 'react-router-dom';

class TsMenuList extends React.Component {

	render () {
		return (
			<ul className="menuList mw800 m-auto">
				<li className="ptm">
					<h4 className="proxima">
						Voulez-vous afficher la liste et le détail des sprints ? 
						<Link to="/sprints" className="pls proxima-bold">Oui</Link>
					</h4>
				</li>
				<li className="ptm">
					<h4 className="proxima">
						Voulez-vous afficher la liste et le détail des testeurs ? 
						<span className="pls proxima-bold">Bientôt</span>
					</h4>
				</li>
				<li className="ptm">
					<h4 className="proxima">
						Voulez-vous afficher la liste et le détail des développeurs ? 
						<span className="pls proxima-bold">Un peu plus tard</span>
					</h4>
				</li>
				<li className="ptm">
					<h4 className="proxima">
						Voulez-vous afficher la liste et le détail des années ? 
						<span className="pls proxima-bold">Peut-être un jour</span>
					</h4>
				</li>
			</ul>
		);
	}
}

export default TsMenuList;


// WEBPACK FOOTER //
// ./src/js/TsMenuList.jsx